import { atarrayaApi } from '../../api-common'

export const state = {
  warehouses: [],
  warehousesSimple: [],
  unitMeasures: [],
  categoryItems: [],
  items: [],
  stocks: [],
  entrances: [],
  exits: [],
  transactions: [],
  transactionDetails: [],
  physicalInventory: [],
  physicalInventoryReview: [],
  physicalInventoryAudit: [],
  physicalInventoryAuditDetail: [],
  additives: [],
  inventoryDesviationReport: [],
  exitsSummary: [],
}

export const getters = {
  warehouses: (state) => state.warehouses,
  warehousesSimple: (state) => state.warehousesSimple,
  unitMeasures: (state) => state.unitMeasures,
  categoryItems: (state) => state.categoryItems,
  items: (state) => state.items,
  stocks: (state) => state.stocks,
  entrances: (state) => state.entrances,
  exits: (state) => state.exits,
  transactions: (state) => state.transactions,
  transactionDetails: (state) => state.transactionDetails,
  physicalInventory: (state) => state.physicalInventory,
  physicalInventoryReview: (state) => state.physicalInventoryReview,
  physicalInventoryAudit: (state) => state.physicalInventoryAudit,
  physicalInventoryAuditDetail: (state) => state.physicalInventoryAuditDetail,
  additives: (state) => state.additives,
  inventoryDesviationReport: (state) => state.inventoryDesviationReport,
  exitsSummary: (state) => state.exitsSummary
}

export const mutations = {
  LOAD_WAREHOUSES(state, data) {
    state.warehouses = data
  },

  LOAD_WAREHOUSES_SIMPLE(state, data) {
    state.warehousesSimple = data
  },

  ADD_WAREHOUSE(state, data) {
    state.warehouses.push(data)
  },

  UPDATE_WAREHOUSE(state, data) {
    const index = state.warehouses.findIndex((f) => f.id === data.id)
    if (index >= 0) {
      for (const attr in data) {
        if (Object.hasOwnProperty.call(state.warehouses[index], attr)) {
          state.warehouses[index][attr] = data[attr]
        }
      }
    }
  },

  DELETE_WAREHOUSE(state, item) {
    state.warehouses.splice(state.warehouses.indexOf(item), 1)
  },

  LOAD_UNIT_MEASURES(state, data) {
    state.unitMeasures = data
  },

  ADD_UNIT_MEASURE(state, data) {
    state.unitMeasures.push(data)
  },

  DELETE_UNIT_MEASURE(state, item) {
    state.unitMeasures.splice(state.unitMeasures.indexOf(item), 1)
  },

  LOAD_CATEGORY_ITEMS(state, data) {
    state.categoryItems = data
  },

  ADD_CATEGORY_ITEM(state, data) {
    state.categoryItems.push(data)
  },

  UPDATE_CATEGORY_ITEM(state, data) {
    const index = state.categoryItems.findIndex((f) => f.id === data.id)
    if (index >= 0) {
      for (const attr in data) {
        if (Object.hasOwnProperty.call(state.categoryItems[index], attr)) {
          state.categoryItems[index][attr] = data[attr]
        }
      }
    }
  },

  DELETE_CATEGORY_ITEM(state, item) {
    state.categoryItems.splice(state.categoryItems.indexOf(item), 1)
  },

  LOAD_ITEMS(state, data) {
    state.items = data
  },

  ADD_ITEM(state, data) {
    state.items.push(data)
  },

  UPDATE_ITEM(state, data) {
    const index = state.items.findIndex((f) => f.id === data.id)
    if (index >= 0) {
      for (const attr in data) {
        if (Object.hasOwnProperty.call(state.items[index], attr)) {
          state.items[index][attr] = data[attr]
        }
      }
    }
  },

  DELETE_ITEM(state, item) {
    state.items.splice(state.items.indexOf(item), 1)
  },

  LOAD_STOCK(state, data) {
    state.stocks = data
  },

  LOAD_ENTRANCE(state, data) {
    state.entrances = data
  },

  ADD_ENTRANCE(state, data) {
    state.entrances.push(data)
  },

  ADD_EXITS(state, data) {
    state.exits.push(data)
  },

  LOAD_TRANSACTIONS(state, data) {
    state.transactions = data
  },

  LOAD_TRANSACTIONS_DETAILS(state, data) {
    state.transactionDetails = data
  },

  LOAD_PHYSICAL_INVENTORY(state, data) {
    state.physicalInventory = data
  },

  ADD_PHYSICAL_INVENTORY_REVIEW(state, data) {
    state.physicalInventoryReview.push(data)
  },

  LOAD_PHYSICAL_INVENTORY_AUDIT(state, data) {
    state.physicalInventoryAudit = data
  },

  LOAD_PHYSICAL_INVENTORY_AUDIT_DETAIL(state, data) {
    state.physicalInventoryAuditDetail = data
  },

  LOAD_PHYSICAL_INVENTORY_AUDIT_DETAIL_MARK_CONFLICT(state, item) {
    state.physicalInventoryAuditDetail.splice(
      state.physicalInventoryAuditDetail.indexOf(item),
      1
    )
  },

  LOAD_ADDITIVES(state, data) {
    state.additives = data
  },

  LOAD_INVETORY_DESVIATION_REPORT(state, data) {
    state.inventoryDesviationReport = data
  },

  LOAD_EXITS_BY_POPULATIONS(state, data) {
    state.exitsSummary = data
  },
}

export const actions = {
  async getWarehouses({ commit }, data) {
    const response = await atarrayaApi.get('/inventory/warehouses', {
      params: {
        farm: data.farmId
      }
    })
    commit('LOAD_WAREHOUSES', response.data.data)
    return response.data.data
  },

  async getWarehousesSimple({ commit }) {
    const response = await atarrayaApi.get('/inventory/warehouses')
    commit('LOAD_WAREHOUSES', response.data.data)
    return response.data.data
  },

  async addWarehouse({ commit }, data) {
    const response = await atarrayaApi.post('/inventory/warehouses', data)
    commit('ADD_WAREHOUSE', response.data.data)
  },

  async editWarehouse({ commit }, data) {
    await atarrayaApi.patch(`/inventory/warehouses/${data.id}`, data)
    commit('UPDATE_WAREHOUSE', data)
  },

  async deleteWarehouse({ commit }, item) {
    await atarrayaApi.delete(`/inventory/warehouses/${item.id}`)
    commit('DELETE_WAREHOUSE', item)
  },

  async getUnitMeasures({ commit }) {
    const response = await atarrayaApi.get('/inventory/measurement-units')
    commit('LOAD_UNIT_MEASURES', response.data.data)
    return response.data.data
  },

  async addUnitMeasure({ commit }, data) {
    const response = await atarrayaApi.post(
      '/inventory/measurement-units',
      data
    )
    commit('ADD_UNIT_MEASURE', response.data.data)
  },

  async deleteUnitMeasure({ commit }, item) {
    await atarrayaApi.delete(`/inventory/measurement-units/${item.id}`)
    commit('DELETE_UNIT_MEASURE', item)
  },

  async getCategoryItems({ commit }) {
    const response = await atarrayaApi.get('/inventory/item-categories')
    commit('LOAD_CATEGORY_ITEMS', response.data.data)
    return response.data.data
  },

  async addCategoryItem({ commit }, data) {
    const response = await atarrayaApi.post('/inventory/item-categories', data)
    commit('ADD_CATEGORY_ITEM', response.data.data)
  },

  async editCategoryItem({ commit }, data) {
    await atarrayaApi.patch(`/inventory/item-categories/${data.id}`, data)
    commit('UPDATE_CATEGORY_ITEM', data)
  },

  async deleteCategoryItem({ commit }, item) {
    await atarrayaApi.delete(`/inventory/item-categories/${item.id}`)
    commit('DELETE_CATEGORY_ITEM', item)
  },

  async getItems({ commit }, farmId) {
    const response = await atarrayaApi.get('/inventory/items', {
      params: { farm: farmId }
    })
    commit('LOAD_ITEMS', response.data.data)
    return response.data.data
  },

  async getItemsSearchs({ commit }, data) {
    const response = await atarrayaApi.get(
      `/inventory/stock/${data.warehouseId}`,
      {
        params: { key: data.key, name: data.name, farm: data.farm }
      }
    )
    commit('LOAD_ITEMS', response.data.data)
    return response.data.data
  },

  async addItem({ commit }, data) {
    const response = await atarrayaApi.post('/inventory/items', data)
    commit('ADD_ITEM', response.data.data)
  },

  async editItem({ commit }, data) {
    await atarrayaApi.patch(`/inventory/items/${data.id}`, data)
    commit('UPDATE_ITEM', data)
  },

  async deleteItem({ commit }, item) {
    await atarrayaApi.delete(`/inventory/items/${item.id}`)
    commit('DELETE_ITEM', item)
  },

  async getStock({ commit }, data) {
    const response = await atarrayaApi.get(
      `/inventory/stock/${data.warehouseId}`,
      {
        params: { farm: data.farm }
      }
    )
    commit('LOAD_STOCK', response.data.data)
    return response.data.data
  },

  async addEntrance({ commit }, data) {
    const response = await atarrayaApi.post('/inventory/entrances', data)
    commit('ADD_ENTRANCE', response.data.data)
  },

  async addExit({ commit }, data) {
    const response = await atarrayaApi.post('/inventory/exits', data)
    commit('ADD_EXITS', response.data.data)
  },

  async getTransaction({ commit }, data) {
    const response = await atarrayaApi.get('/inventory/transactions', {
      params: {
        wh: data.warehouseId,
        type: data.transactionType,
        startingAt: data.startingAt,
        endingAt: data.endingAt
      }
    })
    commit('LOAD_TRANSACTIONS', response.data.data)
    return response.data.data
  },

  async getTransactionDetail({ commit }, data) {
    const response = await atarrayaApi.get(
      `/inventory/${data.type}/${data.transactionId}`,
      {
        params: {
          warehouseId: data.warehouseId
        }
      }
    )
    commit('LOAD_TRANSACTIONS_DETAILS', response.data.data)
    return response.data.data
  },

  async addReturn({ commit }, data) {
    const response = await atarrayaApi.post(
      '/inventory/entrances/returns',
      data
    )
    commit('LOAD_TRANSACTIONS_DETAILS', response.data.data)
  },

  async getPhysicalTemplate({ commit }, data) {
    const response = await atarrayaApi.get(
      '/inventory/physical-inventory/template',
      {
        params: {
          warehouseId: data.warehouseId
        }
      }
    )
    commit('LOAD_PHYSICAL_INVENTORY', response.data.data)
    return response.data.data
  },

  async addPhysicalReview({ commit }, data) {
    const response = await atarrayaApi.post(
      '/inventory/physical-inventory',
      data
    )
    commit('ADD_PHYSICAL_INVENTORY_REVIEW', response.data.data)
  },

  async getPhysicalInventoryAudit({ commit }, data) {
    const response = await atarrayaApi.get('/inventory/physical-inventory', {
      params: {
        wh: data.wh,
        status: [
          'started',
          'review_needed',
          'resolving_conflicts',
          'applying_adjustments'
        ]
      }
    })
    commit('LOAD_PHYSICAL_INVENTORY_AUDIT', response.data.data)
    return response.data.data
  },

  async getPhysicalInventoryAuditDetail({ commit }, inventary) {
    const response = await atarrayaApi.get(
      `/inventory/physical-inventory/${inventary}/items`
    )
    commit('LOAD_PHYSICAL_INVENTORY_AUDIT_DETAIL', response.data.data)
    return response.data.data
  },

  async getPhysicalInventoryAuditDetailMarkConflicts({ commit }, data) {
    const response = await atarrayaApi.patch(
      `/inventory/physical-inventory/${data.inventory}/conflicts`,
      data
    )
    commit(
      'LOAD_PHYSICAL_INVENTORY_AUDIT_DETAIL_MARK_CONFLICT',
      response.data.data
    )
  },

  async getPhysicalInventoryAuditDetailReview({ commit }, data) {
    const response = await atarrayaApi.patch(
      `/inventory/physical-inventory/${data.inventory}/review`,
      data
    )
    commit(
      'LOAD_PHYSICAL_INVENTORY_AUDIT_DETAIL_MARK_CONFLICT',
      response.data.data
    )
  },

  async addPhysicalAuditByType({ commit }, data) {
    const response = await atarrayaApi.post(
      `/inventory/physical-inventory/${data.inventory}/${data.record}`,
      data
    )
    commit('ADD_PHYSICAL_INVENTORY_REVIEW', response.data.data)
  },

  async getPhysicalInventoryReport({ commit }, data) {
    const response = await atarrayaApi.get('/inventory/physical-inventory', {
      params: {
        wh: data.wh,
        status: ['finished', 'finished_with_differences'],
        from: data.from,
        to: data.to
      }
    })
    commit('LOAD_PHYSICAL_INVENTORY_AUDIT', response.data.data)
    return response.data.data
  },

  async getInventoryDesviationReport({ commit }, inventoryId) {
    const response = await atarrayaApi.get(`/inventory/physical-inventory/${inventoryId}/report`)
    commit('LOAD_INVETORY_DESVIATION_REPORT', response.data.data)
    return response.data.data
  },

  async getPhysicalInventoryReportEntrances({ commit }, data) {
    const response = await atarrayaApi.get(
      `/inventory/entrances/${data.transactionId}`,
      {
        params: {
          warehouseId: data.warehouseId
        }
      }
    )
    commit('LOAD_ENTRANCE', response.data.data)
    return response.data.data
  },

  async getAdditives({ commit }, data) {
    const response = await atarrayaApi.get(
      '/inventory/stock/items-with-stock',
      {
        params: {
          farmId: data.farmId,
          key: data.key
        }
      }
    )
    commit('LOAD_ADDITIVES', response.data.data)
    return response.data.data
  },

  async getSummaryReport({ commit }, populationIds) {
    const response = await atarrayaApi.get('/inventory/exits/summary-report', {
      params: { populationId: populationIds }
    })
    commit('LOAD_EXITS_BY_POPULATIONS', response.data.data)
    return response.data.data
  },

}
